import { motion } from 'framer-motion'
import { SectionTitle } from '@/components/SectionTitle'
import { useLanguage } from '@/i18n/LanguageContext'

const technologies = [
  'React',
  '.NET / ASP.NET Core',
  'Node.js',
  'SQL Server',
  'PostgreSQL',
  'APIs REST',
  'Cloud / AWS',
  'Docker',
  'Git',
  'Azure DevOps',
]

export function Tecnologias() {
  const { t } = useLanguage()

  return (
    <section id="tecnologias" className="section-padding bg-slate-50">
      <div className="container-custom">
        <SectionTitle
          title={t.tecnologias.title}
          subtitle={t.tecnologias.subtitle}
        />
        <motion.div
          className="flex flex-wrap justify-center gap-3 md:gap-4"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: '-50px' }}
          transition={{ duration: 0.5 }}
        >
          {technologies.map((tech, i) => (
            <motion.span
              key={tech}
              className="inline-flex items-center rounded-full bg-white px-5 py-2.5 text-sm font-semibold text-slate-700 shadow-sm border border-slate-200 hover:border-primary-300 hover:text-primary-700 hover:shadow-md transition-all duration-300"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.03 }}
            >
              {tech}
            </motion.span>
          ))}
        </motion.div>
      </div>
    </section>
  )
}
